export const COUNTRY_NAME_TO_ALPHA3: Record<string, string> = {
  afghanistan: "AFG",
  "aland islands": "ALA",
  albania: "ALB",
  algeria: "DZA",
  "american samoa": "ASM",
  andorra: "AND",
  angola: "AGO",
  anguilla: "AIA",
  antarctica: "ATA",
  "antigua and barbuda": "ATG",
  argentina: "ARG",
  armenia: "ARM",
  aruba: "ABW",
  australia: "AUS",
  austria: "AUT",
  azerbaijan: "AZE",
  bahamas: "BHS",
  bahrain: "BHR",
  bangladesh: "BGD",
  barbados: "BRB",
  belarus: "BLR",
  belgium: "BEL",
  belize: "BLZ",
  benin: "BEN",
  bermuda: "BMU",
  bhutan: "BTN",
  bolivia: "BOL",
  "bonaire, sint eustatius and saba": "BES",
  "bosnia and herzegovina": "BIH",
  botswana: "BWA",
  "bouvet island": "BVT",
  brazil: "BRA",
  "british indian ocean territory": "IOT",
  "brunei darussalam": "BRN",
  bulgaria: "BGR",
  "burkina faso": "BFA",
  burundi: "BDI",
  "cabo verde": "CPV",
  cambodia: "KHM",
  cameroon: "CMR",
  canada: "CAN",
  "cayman islands": "CYM",
  "central african republic": "CAF",
  chad: "TCD",
  chile: "CHL",
  china: "CHN",
  "christmas island": "CXR",
  "cocos (keeling) islands": "CCK",
  colombia: "COL",
  comoros: "COM",
  congo: "COG",
  "congo (democratic republic)": "COD",
  "cook islands": "COK",
  "costa rica": "CRI",
  "côte d’ivoire": "CIV",
  croatia: "HRV",
  cuba: "CUB",
  curaçao: "CUW",
  cyprus: "CYP",
  czechia: "CZE",
  denmark: "DNK",
  djibouti: "DJI",
  dominica: "DMA",
  "dominican republic": "DOM",
  ecuador: "ECU",
  egypt: "EGY",
  "el salvador": "SLV",
  "equatorial guinea": "GNQ",
  eritrea: "ERI",
  estonia: "EST",
  eswatini: "SWZ",
  ethiopia: "ETH",
  "falkland islands": "FLK",
  "faroe islands": "FRO",
  fiji: "FJI",
  finland: "FIN",
  france: "FRA",
  "french guiana": "GUF",
  "french polynesia": "PYF",
  "french southern territories": "ATF",
  gabon: "GAB",
  gambia: "GMB",
  georgia: "GEO",
  germany: "DEU",
  ghana: "GHA",
  gibraltar: "GIB",
  greece: "GRC",
  greenland: "GRL",
  grenada: "GRD",
  guadeloupe: "GLP",
  guam: "GUM",
  guatemala: "GTM",
  guernsey: "GGY",
  guinea: "GIN",
  "guinea-bissau": "GNB",
  guyana: "GUY",
  haiti: "HTI",
  "heard island and mcdonald islands": "HMD",
  "holy see": "VAT",
  honduras: "HND",
  "hong kong": "HKG",
  hungary: "HUN",
  iceland: "ISL",
  india: "IND",
  indonesia: "IDN",
  iran: "IRN",
  iraq: "IRQ",
  ireland: "IRL",
  "isle of man": "IMN",
  israel: "ISR",
  italy: "ITA",
  jamaica: "JAM",
  japan: "JPN",
  jersey: "JEY",
  jordan: "JOR",
  kazakhstan: "KAZ",
  kenya: "KEN",
  kiribati: "KIR",
  "korea (north)": "PRK",
  "korea (south)": "KOR",
  kuwait: "KWT",
  kyrgyzstan: "KGZ",
  laos: "LAO",
  latvia: "LVA",
  lebanon: "LBN",
  lesotho: "LSO",
  liberia: "LBR",
  libya: "LBY",
  liechtenstein: "LIE",
  lithuania: "LTU",
  luxembourg: "LUX",
  macao: "MAC",
  madagascar: "MDG",
  malawi: "MWI",
  malaysia: "MYS",
  maldives: "MDV",
  mali: "MLI",
  malta: "MLT",
  "marshall islands": "MHL",
  martinique: "MTQ",
  mauritania: "MRT",
  mauritius: "MUS",
  mayotte: "MYT",
  mexico: "MEX",
  micronesia: "FSM",
  moldova: "MDA",
  monaco: "MCO",
  mongolia: "MNG",
  montenegro: "MNE",
  montserrat: "MSR",
  morocco: "MAR",
  mozambique: "MOZ",
  myanmar: "MMR",
  namibia: "NAM",
  nauru: "NRU",
  nepal: "NPL",
  netherlands: "NLD",
  "new caledonia": "NCL",
  "new zealand": "NZL",
  nicaragua: "NIC",
  niger: "NER",
  nigeria: "NGA",
  niue: "NIU",
  "norfolk island": "NFK",
  "northern mariana islands": "MNP",
  norway: "NOR",
  oman: "OMN",
  pakistan: "PAK",
  palau: "PLW",
  panama: "PAN",
  "papua new guinea": "PNG",
  paraguay: "PRY",
  peru: "PER",
  philippines: "PHL",
  pitcairn: "PCN",
  poland: "POL",
  portugal: "PRT",
  "puerto rico": "PRI",
  qatar: "QAT",
  réunion: "REU",
  romania: "ROU",
  russia: "RUS",
  rwanda: "RWA",
  "saint barthélemy": "BLM",
  "saint helena": "SHN",
  "saint kitts and nevis": "KNA",
  "saint lucia": "LCA",
  "saint martin": "MAF",
  "saint pierre and miquelon": "SPM",
  "saint vincent and the grenadines": "VCT",
  samoa: "WSM",
  "san marino": "SMR",
  "sao tome and principe": "STP",
  "saudi arabia": "SAU",
  senegal: "SEN",
  serbia: "SRB",
  seychelles: "SYC",
  "sierra leone": "SLE",
  singapore: "SGP",
  "sint maarten": "SXM",
  slovakia: "SVK",
  slovenia: "SVN",
  "solomon islands": "SLB",
  somalia: "SOM",
  "south africa": "ZAF",
  "south georgia": "SGS",
  "south sudan": "SSD",
  spain: "ESP",
  "sri lanka": "LKA",
  sudan: "SDN",
  suriname: "SUR",
  "svalbard and jan mayen": "SJM",
  sweden: "SWE",
  switzerland: "CHE",
  "syrian arab republic": "SYR",
  taiwan: "TWN",
  tajikistan: "TJK",
  tanzania: "TZA",
  thailand: "THA",
  "timor-leste": "TLS",
  togo: "TGO",
  tokelau: "TKL",
  tonga: "TON",
  "trinidad and tobago": "TTO",
  tunisia: "TUN",
  turkey: "TUR",
  turkmenistan: "TKM",
  "turks and caicos islands": "TCA",
  tuvalu: "TUV",
  uganda: "UGA",
  ukraine: "UKR",
  "united arab emirates": "ARE",
  "united kingdom": "GBR",
  "united states": "USA",
  "united states of america": "USA",
  uruguay: "URY",
  uzbekistan: "UZB",
  vanuatu: "VUT",
  venezuela: "VEN",
  "viet nam": "VNM",
  "virgin islands (british)": "VGB",
  "virgin islands (us)": "VIR",
  "wallis and futuna": "WLF",
  "western sahara": "ESH",
  yemen: "YEM",
  zambia: "ZMB",
  zimbabwe: "ZWE",
};
